import React from "react";
import { QuestionItem } from "../TopicPreview";
import styles from "./index.module.scss";
import TopicPreviewItem from "../TopicPreviewItem";

interface TopicPreviewGroupProps {
    data: QuestionItem;
}

export default function TopicPreviewGroup({ data }: TopicPreviewGroupProps) {
    return (
        <div className={styles.root}>
            <div className={styles.info}>{data.queTypeName}</div>

            <div className={styles.trunk}>
                <div
                    className={styles.title}
                    dangerouslySetInnerHTML={{
                        __html: data?.contentText
                    }}
                />
            </div>

            {data.questionModelList?.map(
                (item: QuestionItem, index: number) => (
                    <div className={styles.item} key={index}>
                        <TopicPreviewItem data={item} />
                    </div>
                )
            )}
        </div>
    );
}
